import { splitText, reverseSplit } from '../utils';
import { gsap, ScrollTrigger } from '../libraries/gsap/index';

export default class TextSplitScrollTrigger {
  constructor({
    el,
    splitText,
    animate,
    reverse,
    start = 'top bottom', // "top top+=100%",
    end = 'bottom top', // "bottom bottom-=100%",
    scrub = false,
    once = true,
    shouldReverseSplit = true,
  }) {
    this.element = el;
    this.splitText = splitText;
    this.splits = [];
    this.animateCallback = animate || (() => {});
    this.reverseCallback = reverse || (() => {});
    this.start = start;
    this.end = end;
    this.scrub = scrub;
    this.once = once;
    this.shouldReverseSplit = shouldReverseSplit;

    if (!this.splitText[0]) return;

    this.initScrollTrigger();
  }

  initScrollTrigger() {
    document.fonts.ready.then(() => {
      this.myScrollTrigger = ScrollTrigger.create({
        trigger: this.element,
        start: this.start,
        end: this.end,
        scrub: this.scrub,
        once: this.once,
        onEnter: () => this.handleEnter(),
        onLeave: () => this.handleLeave(),
      });
    });
  }

  handleEnter() {
    const split = splitText(this.splitText);
    split.on('ready', (splits) => {
      this.splits = [...splits];
      this.animateCallback();
    });
  }

  handleLeave() {
    if (this.shouldReverseSplit === false) return;

    reverseSplit(this.splits);
    this.reverseCallback();
    this.myScrollTrigger.kill();
  }
}
